export class LoadModules {
  static readonly type = '[Module] Load Modules';
  constructor() {}
}
